import { api } from "./client";

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  profile: string;
  photo?: string;
}

interface LoginResponse {
  token: string;
  user: AuthUser;
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>("/auth/login", { email, password }),
  me: () => api.get<AuthUser>("/auth/me"),
};
